export const SIDEBAR_ROUTES = {
  INTEGRATIONS: {
    TITLE: 'Integrations',
    IMAGE_NAME: 'connectors'
  },
  CUSTOM_OBJECT: {
    TITLE: 'Custom Object',
    ROUTE: '/app/custom-object',
  }
}

export const DROPDOWN_SIDEBAR_ROUTES = {
  CUSTOM_CONNECTORS: {
    TITLE: 'Apps',
    ROUTE: '/app/custom-connectors',
  },
  DEVELOPER_APIS: {
    TITLE: 'Developer APIs',
    ROUTE: '/app/developer',
  },
    CUSTOM_CONNECTORS_OLD: {
    TITLE: 'Custom Connectors',
    ROUTE: '/app/custom-connectors',
  }
}
